import React from 'react'
import { useSelector } from 'react-redux'
import { Notification } from '../../../../../../../common/notification'
import { getHighlightScore } from '../../../../../store/slice'
import {
  selectBreakdownCompare,
  selectRiskDriversIsAdjust,
  selectRiskDriversNoteAdjust,
} from '../../../../store/slice'
import RelativeContributions from './RelativeContributions'
import { RiskDriversTable } from './RiskDriversTable'
import ScoreBreakdown from './ScoreBreakdown'
import styles from './index.module.scss'

const RiskComponentAnalysisDynamic = ({
  isCompare,
  filterTime = { from: null, to: null },
  arrValueDynamic,
  isDynamicReport,
  viewBy,
}) => {
  const riskDriversIsAdjust = useSelector(selectRiskDriversIsAdjust)
  const riskDriversNoteAdjust = useSelector(selectRiskDriversNoteAdjust)
  const { baseData, compareData } = useSelector(selectBreakdownCompare)
  const { riskScore } = useSelector(getHighlightScore())

  const showScoreBreakdown =
    viewBy === 'Chart' && arrValueDynamic.includes('scoreBreakdown')
  const showRelativeContributions =
    viewBy === 'Chart' && arrValueDynamic.includes('relativeContributions')
  const showRiskDriversTable = viewBy === 'Table'

  return (
    <>
      {riskScore === null || riskScore === undefined ? (
        <div style={{ height: 200 }}>
          <Notification />
        </div>
      ) : (
        <div style={{ padding: 12 }}>
          {riskScore === 0 ? (
            <>
              {isCompare &&
              (baseData.filter((item) => item.scoreValue > 0).length ||
                compareData.filter((item) => item.scoreValue > 0).length) ? (
                <>
                  {riskDriversIsAdjust && (
                    <div className={styles.noteAdjust}>
                      {riskDriversNoteAdjust}
                    </div>
                  )}
                  <div>
                    {showScoreBreakdown && (
                      <ScoreBreakdown
                        isCompare={isCompare}
                        filterTime={filterTime}
                        isDynamicReport={isDynamicReport}
                      />
                    )}
                    {showRelativeContributions && (
                      <RelativeContributions
                        isDynamicReport={isDynamicReport}
                      />
                    )}
                    {showRiskDriversTable && (
                      <RiskDriversTable
                        isCompare={isCompare}
                        isDynamicReport={isDynamicReport}
                      />
                    )}
                  </div>
                </>
              ) : (
                <div
                  className="mt2 dFlex justifyContentCenter alignItemsCenter"
                  style={{ minHeight: 200 }}
                >
                  <Notification isI18n value="riskComponentAnalysis.noData" />
                </div>
              )}
            </>
          ) : (
            <>
              {riskDriversIsAdjust && (
                <div className={styles.noteAdjust}>{riskDriversNoteAdjust}</div>
              )}
              <div>
                {showScoreBreakdown && (
                  <ScoreBreakdown
                    isCompare={isCompare}
                    filterTime={filterTime}
                    isDynamicReport={isDynamicReport}
                  />
                )}
                {showRelativeContributions && (
                  <RelativeContributions isDynamicReport={isDynamicReport} />
                )}
                {showRiskDriversTable && (
                  <RiskDriversTable
                    isCompare={isCompare}
                    isDynamicReport={isDynamicReport}
                  />
                )}
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}

export default RiskComponentAnalysisDynamic
